<style scoped lang="scss" type="text/scss">
    .consignee-container {

    }
</style>

<template>
    <div class="consignee-container">
        <el-form :model="consigneeInfo" :rules="rules" ref="form" label-width="90px">
            <block-divider>收件人信息</block-divider>

            <el-form-item label="姓名" prop="name">
                <el-input v-model.trim="consigneeInfo.name" placeholder="请输入收件人姓名"></el-input>
            </el-form-item>

            <el-form-item label="手机号" prop="mobile">
                <el-input v-model.trim="consigneeInfo.mobile" placeholder="请输入 11 位手机号码"></el-input>
            </el-form-item>

            <block-divider>地址信息</block-divider>

            <el-form-item label="省市区" prop="region_id">
                <province-city-county-selector v-model="consigneeInfo.region_id"></province-city-county-selector>
            </el-form-item>

            <el-form-item label="详细地址" prop="detail">
                <el-input v-model="consigneeInfo.detail" placeholder="请输入街道、门牌号等详细地址"></el-input>
            </el-form-item>

            <el-form-item class="submit-buttons">
                <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
                <el-button @click="reset()">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import ProvinceCityCountySelector from '../../../../sub-components/province-city-county-selector';
    import _ from 'lodash';
    import {isMobile} from '../../../../../utils/regex';

    export default {
        name: '',
        components: {
            BlockDivider,
            ProvinceCityCountySelector
        },
        data () {
            const checkMobile = async (rule, value, callback) => {
                if (!isMobile(value)) {
                    callback(new Error('请输入正确的 11 位手机号'));
                }
            };

            return {
                requesting: false,
                consigneeInfo: {},
                rules: {
                    mobile: [
                        {required: true, message: '收件人手机号不能为空', trigger: 'blur'},
                        {validator: checkMobile, trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '收件人姓名不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                    ],
                    region_id: [
                        {required: true, message: '请选择省市区信息', trigger: 'blur'}
                    ],
                    subject_id: [
                        {required: true, message: '请选择专业信息', trigger: 'blur'}
                    ],
                    detail: [
                        {required: true, message: '详细地址不能为空', trigger: 'blur'},
                        {min: 1, max: 60, message: '长度不能超过 60 个字', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            currentManagedPlayerInfo () {
                return this.$store.state.player.currentManagedPlayerInfo;
            }
        },
        watch: {
            currentManagedPlayerInfo: {
                immediate: true,
                handler (info) {
                    this.consigneeInfo = this.extract(info.player_consignee);
                }
            }
        },
        methods: {
            extract (info) {
                return {
                    name: _.get(info, 'name', null),
                    mobile: _.get(info, 'mobile', null),
                    region_id: _.get(info, 'address.region_id', null),
                    detail: _.get(info, 'address.detail', null)
                };
            },
            update () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    this.$normalRequest('player/updateConsignee', {
                        id: this.currentManagedPlayerId,
                        ...this.consigneeInfo
                    }, '更新成功', true, this, 'requesting').then(_ => {
                        this.$refs.form.clearValidate();
                        this.$store.dispatch('player/loadRegistrableManagedPlayerInfo').then();
                    }).catch(_ => {
                    });
                });
            },
            reset () {
                this.consigneeInfo = this.extract(this.currentManagedPlayerInfo.player_consignee);
                this.$refs.form.clearValidate();
            }
        }
    };
</script>
